import { DownloadIcon } from "@heroicons/react/outline";
import { useOne, useTranslation } from "@refinedev/core";
import Button from "components/button";
import { FullScreenLoading } from "components/fullScreenLoading";
import { UserType } from "interfaces";
import { get } from "lodash";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { twMerge } from "tailwind-merge";

interface ExportButtonProps {
  className?: string;
  filters?: any;
  resource: string;
  title: string;
  type?: UserType;
}
export const ExportButton = ({
  filters,
  className,
  resource,
  title,
  type = UserType.ADMIN,
}: ExportButtonProps) => {
  const [exportId, setExportId] = useState<string | null>();
  const { translate } = useTranslation();

  const { refetch: checkStatus } = useOne({
    resource: "export/result",
    id: exportId ?? "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: false,
    } as any,
    errorNotification: (data, values, resource) => {
      setExportId(null);
      return {
        message: `Export Error`,
        description: "Export Error",
        type: "error",
      };
    },
  });

  const { refetch: getExportData, isFetching: isFetchingExportData } =
    useOne<any>({
      resource: resource,
      id: "",
      meta: {
        resource: "data",
        filters: filters ?? null,
      },
      queryOptions: {
        enabled: false, // Disable automatic fetching
      } as any,
    });

  useEffect(() => {
    let intervalId: any;

    if (exportId) {
      intervalId = setInterval(() => {
        checkStatus().then((data) => {
          const isSuccess = get(data, "data.data.is_success", false);
          if (isSuccess) {
            setExportId(null);
            window.location.href = get(data, "data.data.file_link", "#");
          }
        });
      }, 2000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [exportId, checkStatus]);

  const _checkStatus = (id: string) => {
    setExportId(id);
  };

  const _exportData = () => {
    getExportData().then((res) => {
      if (res.isSuccess) {
        const exportId = get(res, "data.data.export_id", "");
        if (exportId) {
          if (type === UserType.ADMIN) {
            _checkStatus(exportId);
          } else {
            toast.success(translate("export-success"));
          }
        }
      }
    });
  };

  return (
    <>
      <Button
        onClick={_exportData}
        className={twMerge("w-11 h-11 sm:w-auto", className)}
        disabled={isFetchingExportData}
      >
        <span className="sr-only">{title}</span>
        <DownloadIcon className="w-4 h-4 text-inherit" />{" "}
        <span className="hidden sm:block sm:ml-2">{title}</span>
      </Button>
      {exportId ? <FullScreenLoading /> : <></>}
    </>
  );
};
